// ContactUs.js
import React from "react";
import {  Row, Col, Form, Button } from "react-bootstrap";
import ContactHeroImg from "../../asset/Gallery.webp"; // Hero image
import ContactSideImg from "../../asset/mobile.webp";  // Left-side image
import addressIcon from "../../asset/add.png";    // Address icon
import emailIcon from "../../asset/mail.png";     // Email icon
import phoneIcon from "../../asset/phon.png";     // Phone icon
import FormBgImg from "../../asset/formbg.png";   // <-- New background image for form
import "./Contact.css";

const Contact = () => {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="contact-hero text-white"
        style={{
          backgroundImage: `url(${ContactHeroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "88vh",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "0 20px",
        }}
      >
        {/* Dark overlay */}
        <div className="overlay"></div>

        {/* Text content */}
        <div className="hero-text-container">
          <h1 className="contact-heading">
            <i className="bi bi-handshake-fill"></i> We're Here for You
          </h1>
          <p className="contact-paragraph">
            From inquiries to collaborations, we value every conversation — because great partnerships start with a simple hello.
          </p>
        </div>
      </div>

      {/* Contact Section */}
   <div className="contact-section container-fluid">
  <Row className="align-items-center g-0 justify-content-center">
    {/* Left column - image */}
    <Col md={3} className="text-center mb-4 mb-md-0">
      <img src={ContactSideImg} alt="Contact" className="contact-side-img" />
    </Col>

    {/* Middle column - contact info */}
    <Col md={4} className="mb-4 mb-md-0">
      <div className="contact-info">
        <p>
          <img src={addressIcon} alt="Address" className="contact-icon" />
          06, Landscape Apartment, B/H Amol Pustakalay, Near IDFC Bank,
          Shahid Circle, Gangapur Road, Nashik - 422005
        </p>
        <p>
          <img src={emailIcon} alt="Email" className="contact-icon" />
          casudarshanandcompany@gmail.com
        </p>
        <p>
          <img src={phoneIcon} alt="Phone" className="contact-icon" />
          +91 8080098225 / +91 7875529088
        </p>
      </div>
    </Col>

    {/* Right column - form */}
   <Col
  xs={12}
  sm={10}
  md={10}
  lg={5}
  className="d-flex justify-content-center"
>
  <div
    className="contact-form-box p-4"
    style={{
      backgroundImage: `url(${FormBgImg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      maxWidth: "450px", // optional: prevents it from stretching too wide
      width: "100%",
    }}
  >
    <div className="form-overlay">
      <Form className="contact-form p-2">
        <Form.Group className="mb-3" controlId="fullName">
          <Form.Control type="text" placeholder="Full Name" />
        </Form.Group>
        <Form.Group className="mb-3" controlId="email">
          <Form.Control type="email" placeholder="Email" />
        </Form.Group>
        <Form.Group className="mb-3" controlId="mobile">
          <Form.Control type="text" placeholder="Mobile No" />
        </Form.Group>
        <Form.Group className="mb-3" controlId="message">
  <Form.Control as="textarea" rows={2} placeholder="Message" />
</Form.Group>

     <div className="text-center">
  <Button type="submit" className="submit-btn">
    Send Message
  </Button>
</div>

      </Form>
    </div>
  </div>
</Col>
  </Row>
</div>



        {/* Horizontal Line */}
<div className="contact-divider"></div>

<div
  style={{
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "20px",
    // paddingTop: "20px",
    paddingBottom: "30px",
  }}
>
  <iframe
    title="CA Sudarshan V Kalunge & Company"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3748.9233914187744!2d73.7528206782426!3d20.011729733423792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddebae26087d63%3A0x1b550d7c7ed5c934!2sCA%20SUDARSHAN%20V%20KALUNGE%20%26%20COMPANY!5e0!3m2!1sen!2sin!4v1757328411473!5m2!1sen!2sin"
    width="1100" // Increased width for desktop
    height="600" // Increased height for desktop
    style={{
      border: 0,
      borderRadius: "15px",
      boxShadow: "0 8px 30px rgba(0, 0, 0, 0.3)",
    }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>


      </div>
  
  );
};

export default Contact;
